const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

function escapeHtml(str) {
  return str.replace(/[&<>"']/g, (c) => ESCAPES[c]);
}

/**
 * customTextRenderer for react-pdf: marks PDF text items that share a word
 * (longer than 4 characters) with `content`. react-pdf writes the return value
 * as HTML, and the text comes from an uploaded PDF, so it is escaped first.
 */
export function makeHighlightRenderer(content) {
  if (!content) return undefined;
  const words = new Set(
    content.split(/\s+/).filter((w) => w.length > 4).map((w) => w.toLowerCase())
  );
  return ({ str }) => {
    const safe = escapeHtml(str);
    if (!str.trim()) return safe;
    const isMatch = str.split(/\s+/).some((w) => words.has(w.toLowerCase()));
    return isMatch ? `<mark class="pdf-highlight">${safe}</mark>` : safe;
  };
}
